import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { ChartView } from "../types/power";

interface ChartToggleProps {
  value: ChartView;
  onChange: (next: ChartView) => void;
}

const ChartToggle = ({ value, onChange }: ChartToggleProps) => (
  <ToggleButtonGroup
    value={value}
    exclusive
    onChange={(_, next) => {
      if (next) {
        onChange(next);
      }
    }}
  >
    <ToggleButton value="bar">Room comparison</ToggleButton>
    <ToggleButton value="line">Room trend</ToggleButton>
  </ToggleButtonGroup>
);

export default ChartToggle;
